import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  counterWrapper: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: colour.grey[200],
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 30
  },
  lozenge: {
    color: colour.grey[300],
    background: colour.grey[500],
    borderRadius: 100,
    padding: "5px 11px",
    marginRight: 5
  }
});
